export enum PageTab {
  Templates = 'templates',
  TeamsOn = 'teams-on',
  TeamsWorkingForMe = 'teams-working-for-me',
  Archived = 'archived'
}
